"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var FormValidator_1 = __importDefault(require("../ts/validation/FormValidator"));
var contactformdropdownprefill_1 = __importDefault(require("./contactformdropdownprefill"));
var freeTextFieldPrefill_1 = __importDefault(require("./freeTextFieldPrefill"));
var Contactform = /** @class */ (function () {
    function Contactform(form) {
        var _this = this;
        //initialize FormValidator
        var formValidator = new FormValidator_1.default(form);
        form.attachments = [];
        this.createInputFromSearchParam(form);
        // intercept submit button(s) to perform validation
        form.querySelectorAll('button[type=submit]').forEach(function (item) {
            item.addEventListener('click', function (event) {
                if (!formValidator.validateForm(true)) {
                    event.preventDefault();
                }
            });
        });
        form.querySelectorAll('input[type=file]').forEach(function (item) {
            item.addEventListener('change', function (event) {
                _this.addUploadedFile(formValidator, form, event, item);
                item.value = '';
            });
        });
        form.querySelectorAll('[data-ref-id]').forEach(function (e) {
            _this.toggleRequiredForConditionalContainer(e, false);
        });
        // on page load, conditional containers need to be updated based on input fields' initial values
        form.querySelectorAll('[data-target-id]').forEach(function (el) {
            _this.updateConditionalContainer(form, el);
        });
        // on every change event in the form, we check, if there is a conditional container, which needs to be hidden/shown based on the input
        form.addEventListener('change', function (event) {
            _this.updateConditionalContainer(form, event.target);
        });
        form.addEventListener('submit', function (event) {
            event.preventDefault();
            void _this.fetchData(form);
        });
        // disable default subject option
        if (form.querySelector('#select-subject')) {
            var select = form.querySelector('#select-subject');
            if (select.parentElement.hasAttribute('data-contactform-defaultsubject')) {
                select.options[0].setAttribute('disabled', 'true');
            }
        }
        var dateInputs = document.querySelectorAll("[data-datepicker-mode='range'] input");
        dateInputs.forEach(function (dateInput) {
            dateInput.addEventListener('keypress', function (e) {
                e.preventDefault();
            });
        });
    }
    Contactform.prototype.fetchData = function (form) {
        return __awaiter(this, void 0, void 0, function () {
            var formData, actionUrl, formResponse, response, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        formData = this.createFormData(form);
                        actionUrl = form.getAttribute('action');
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, fetch(actionUrl, {
                                method: 'POST',
                                body: formData,
                            })];
                    case 2:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 3:
                        formResponse = (_a.sent());
                        this.createNotificationBanner(formResponse, response, form);
                        return [3 /*break*/, 5];
                    case 4:
                        err_1 = _a.sent();
                        console.error("Error while posting contactFormData:", err_1);
                        return [2 /*return*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    Contactform.prototype.updateConditionalContainer = function (form, input) {
        var _this = this;
        var isCheckbox = input.classList.contains('c-checkbox__input');
        form.querySelectorAll("[data-ref-id=".concat(input.dataset.targetId, "]")).forEach(function (container) {
            var conditionalContainerValues = container.dataset.refValues.split(',');
            _this.toggleShowConditionalContainer(form, container, conditionalContainerValues, input, isCheckbox);
        });
    };
    Contactform.prototype.createFormData = function (form) {
        form.querySelector('.c-spinner--full-page').setAttribute('aria-busy', 'true');
        form.querySelector('.js-form-spinner').hidden = false;
        form.querySelector('.js-contact-form-submit').disabled = true;
        form.querySelectorAll('.c-input__input').forEach(function (item) {
            item.setAttribute('readOnly', 'true');
        });
        var formData = new FormData(form);
        // Append the attachments to our formData
        var names = '';
        form.attachments.forEach(function (attachment, index) {
            var name = "attachment".concat(index);
            var separator = ',';
            if (index === 0) {
                separator = '';
            }
            names += separator + name;
            formData.append(name, attachment);
        });
        if (form.attachments && form.attachments.length > 0) {
            formData.append('attachmentList', names);
        }
        // Add parameters for headings that are
        //   1. either not inside a conditional container
        //   2. or inside a conditional container that is not hidden
        form.querySelectorAll('.c-form-heading:not(.js-conditional-container .c-form-heading), .js-conditional-container:not(.u-hide) .c-form-heading').forEach(function (heading) {
            var crxName = heading.dataset.crx;
            var headline = heading.dataset.contactFormHeadline;
            var subline = heading.dataset.contactFormSubline;
            formData.append(crxName, '</br>' + heading.innerHTML);
            if (typeof headline !== 'undefined') {
                formData.append('headline', headline);
            }
            if (typeof subline !== 'undefined') {
                formData.append('subline', subline);
            }
        });
        return formData;
    };
    Contactform.prototype.enableForm = function (form) {
        form.querySelector('.js-contact-form-submit').disabled = false;
        form.querySelectorAll('.c-input__input').forEach(function (item) {
            item.removeAttribute('readOnly');
        });
    };
    Contactform.prototype.createNotificationBanner = function (notificationData, fetchResponse, form) {
        var _this = this;
        var notificationElement = document.querySelector('.js-contactform-notification');
        var notificationParent = notificationElement.parentElement;
        var root = document.getElementById('main');
        root.insertBefore(notificationParent, root.childNodes[0]);
        //delete error and success class from notification
        //show server error field if servlet is not available and return
        if (!fetchResponse.headers.get('content-type').includes('json')) {
            console.debug('Contactform: Servlet not available');
            form.querySelector('.c-spinner--full-page').setAttribute('aria-busy', 'false');
            form.querySelector('.js-form-spinner').hidden = true;
            notificationElement.classList.remove('is-closed');
            notificationElement.querySelector('.js-contact-form-show-on-submit-server-error').classList.remove('c-contact-from__hide_field');
            return;
        }
        var textElement = notificationElement.querySelector('.js-contact-form-show-on-submit');
        //on success
        if (fetchResponse.status === 200 && notificationData.status_code === 200) {
            var successPageLink = form.dataset.successPageLink;
            if (successPageLink) {
                window.location.href = successPageLink;
            }
            else {
                form.querySelector('.c-spinner--full-page').setAttribute('aria-busy', 'false');
                form.querySelector('.js-form-spinner').hidden = true;
                notificationElement.classList.remove('is-closed');
                notificationElement.querySelector('.c-notification').classList.remove('c-notification--error');
                notificationElement.querySelector('.c-notification').classList.add('c-notification--success');
                form.querySelector('.js-contact-form-submit').disabled = false;
                this.clearInputElements(form);
                form.querySelectorAll('[data-ref-id]').forEach(function (container) {
                    container
                        .querySelectorAll('input, select')
                        .forEach(function () { return _this.clearConditionalContainer(form, container); });
                });
                textElement.textContent = '';
                textElement.textContent = notificationData.response_text;
                textElement.classList.remove('c-contact-from__hide_field');
                notificationElement
                    .querySelector('.js-contact-form-show-on-submit-server-error')
                    .classList.add('c-contact-from__hide_field');
                // clear the uploaded files section
                if (form.attachments.length > 0) {
                    form.querySelector('.c-upload-container__itemlist').innerHTML = '';
                    form.querySelector('.c-upload__input').dataset.totalFilesize = '0';
                    form.querySelector('.c-upload__input').dataset.filecount = '0';
                    form.attachments = [];
                }
            }
        }
        else {
            console.trace("Contactform: Request failed: ".concat(fetchResponse.status, " / ").concat(fetchResponse.statusText));
            form.querySelector('.c-spinner--full-page').setAttribute('aria-busy', 'false');
            form.querySelector('.js-form-spinner').hidden = true;
            notificationElement.classList.remove('is-closed');
            notificationElement.querySelector('.c-notification').classList.remove('c-notification--success');
            notificationElement.querySelector('.c-notification').classList.add('c-notification--error');
            textElement.textContent = '';
            textElement.textContent = notificationData.response_text;
            textElement.classList.remove('c-contact-from__hide_field');
            if (notificationData.status_code == 400) {
                this.enableForm(form);
            }
        }
    };
    Contactform.prototype.toggleShowConditionalContainer = function (form, container, containerValues, changedInput, isCheckbox) {
        var containerActive = containerValues.includes(changedInput.value) && changedInput.dataset.targetId === container.dataset.refId;
        var checkboxSiblings = document.querySelectorAll("[data-target-id=".concat(changedInput.dataset.targetId, "]"));
        var isSiblingChecked = isCheckbox && checkboxSiblings.length > 1 ? this.isSiblingChecked(checkboxSiblings, changedInput, containerValues) : false;
        if ((containerActive && !isCheckbox) || (isCheckbox && containerActive && changedInput.checked) || isSiblingChecked) {
            container.classList.remove('u-hide');
            this.toggleDisabledForConditionalContainer(container, false);
            this.toggleRequiredForConditionalContainer(container, true);
        }
        else {
            this.clearConditionalContainer(form, container);
            this.toggleDisabledForConditionalContainer(container, true);
            this.toggleRequiredForConditionalContainer(container, false);
            this.checkConditionalChains(form, container);
        }
    };
    Contactform.prototype.isSiblingChecked = function (checkBoxes, changedInput, containerValues) {
        var siblingChecked = false;
        for (var _i = 0, _a = checkBoxes; _i < _a.length; _i++) {
            var cb = _a[_i];
            if (cb.checked && containerValues.includes(cb.value)) {
                siblingChecked = true;
                break;
            }
        }
        return siblingChecked;
    };
    Contactform.prototype.checkConditionalChains = function (form, conditionalContainer) {
        var _this = this;
        conditionalContainer.querySelectorAll('input[data-target-id], select[data-target-id]').forEach(function (input) {
            var targetId = input.dataset.targetId;
            var chainedContainer = form.querySelectorAll("[data-ref-id=".concat(targetId, "]"));
            if (chainedContainer.length > 0) {
                chainedContainer.forEach(function (container) {
                    _this.clearConditionalContainer(form, container);
                    _this.checkConditionalChains(form, container);
                });
            }
        });
    };
    Contactform.prototype.clearConditionalContainer = function (form, container) {
        container.classList.add('u-hide');
        this.clearInputElements(container);
    };
    Contactform.prototype.clearInputElements = function (element) {
        element.querySelectorAll('.c-input__input').forEach(function (item) {
            item.removeAttribute('readOnly');
            item.value = '';
        });
        element.querySelectorAll('.c-checkbox__input, .c-radio__input').forEach(function (item) {
            item.checked = false;
        });
        //clear file upload
        element.querySelectorAll(".c-upload [type='file']").forEach(function (item) {
            item.value = '';
        });
    };
    Contactform.prototype.toggleDisabledForConditionalContainer = function (container, disabled) {
        container.querySelectorAll('.c-input__input').forEach(function (item) {
            item.disabled = disabled;
        });
    };
    Contactform.prototype.toggleRequiredForConditionalContainer = function (container, keepRequired) {
        container.querySelectorAll('[data-keep-required]').forEach(function (el) {
            if (keepRequired) {
                el.setAttribute('required', 'required');
                el.dataset.requiredChanged = 'true';
            }
            else {
                el.removeAttribute('required');
            }
        });
    };
    Contactform.prototype.addUploadedFile = function (formValidator, form, event, item) {
        var isValid = formValidator.validateField(item);
        if (isValid) {
            var currentTarget = event.target;
            var files = currentTarget.files;
            var id = form.attachments.length + 1;
            if (files) {
                for (var _i = 0, files_1 = files; _i < files_1.length; _i++) {
                    var file = files_1[_i];
                    file['id'] = id;
                    id++;
                    form.attachments.unshift(file);
                }
            }
            // Render the attachments each time the input changes
            this.renderUploadList(form, item);
            // Handle delete icon click to remove attachments
            this.handleUploadListItemDeleteClick(form, item, formValidator);
        }
    };
    /**
     * Renders attachments below the form
     */
    Contactform.prototype.renderUploadList = function (form, inputField) {
        var _this = this;
        form.querySelectorAll('.c-upload-container__itemlist').forEach(function (uploadList) {
            // If there are no attachments, we hide the list
            if (form.attachments.length === 0) {
                uploadList.classList.add('u-hide');
            }
            else {
                // If there are attachments, we show the list and render output
                var uploadListItems_1 = '';
                var totalSize_1 = 0;
                uploadList.classList.remove('u-hide');
                // Iterate over each attachment to generate <li> element with corresponding values
                form.attachments.forEach(function (attachment) {
                    totalSize_1 += attachment.size;
                    var icon;
                    switch (attachment.type) {
                        case 'image/jpeg':
                            icon = 'c-icon--[document-jpg]';
                            break;
                        case 'application/pdf':
                            icon = 'c-icon--[document-pdf]';
                            break;
                        default:
                            icon = 'c-icon--[document-checkmark]';
                            break;
                    }
                    // Add list item to list variable
                    uploadListItems_1 += _this.createUploadListItem(attachment, icon);
                });
                // Add the HTML to our uploadList <ul> element
                uploadList.innerHTML = uploadListItems_1;
                inputField.dataset.totalFilesize = totalSize_1.toString();
                inputField.dataset.filecount = form.attachments.length.toString();
            }
        });
    };
    /**
     * Creates a list item for the upload list element
     */
    Contactform.prototype.createUploadListItem = function (attachment, icon) {
        return ("<li class=\"c-upload-container__item\" data-id=\"".concat(attachment.id, " data-filesize=\"").concat(attachment.size, "\">") +
            '<div class="c-upload-item">' +
            '<i class="c-upload-item__icon  c-icon ' +
            icon +
            '"></i>' +
            '<div class="c-upload-item__content">' +
            '<div class="c-upload-item__title-row">' +
            "<span class=\"c-upload-item__title\">".concat(attachment.name, "</span>") +
            '<div class="c-upload-item__interaction-icons">' +
            '<button class="c-upload-item__interaction-icon c-upload-list__icon-delete c-icon c-icon--[bin]" data-tr-component="Button"></button>' +
            '<i class="c-upload-item__interaction-icon c-upload-item__status-icon c-icon c-icon--[checkmark]"></i>' +
            '<i class="c-upload-item__interaction-icon c-upload-item__status-icon c-icon c-icon--[exclamation-mark-triangle]"></i>' +
            '</div>' +
            '</div>' +
            '<p class="c-upload-item__subtitle-row">' +
            '<span class="c-upload-item__filesize">' +
            this.humanFileSize(attachment.size) +
            '</span>' +
            '</div>' +
            '</div>' +
            '</li>');
    };
    /**
     * Handles click on the delete icon in our uploadList
     * to remove that item from the attachments array and the list

     */
    Contactform.prototype.handleUploadListItemDeleteClick = function (form, inputField, validator) {
        var _this = this;
        form.querySelectorAll('.c-upload-container__item').forEach(function (uploadListItem) {
            uploadListItem.querySelectorAll('.c-upload-list__icon-delete').forEach(function (deleteIcon) {
                deleteIcon.addEventListener('click', function () {
                    var id = uploadListItem.dataset.id ? parseInt(uploadListItem.dataset.id) : null;
                    if (id !== null && !isNaN(id)) {
                        _this.removeFile(uploadListItem, form, inputField, validator, id);
                    }
                    else {
                        console.trace('Contactform: Upload item ID is null or NaN');
                    }
                });
            });
        });
    };
    Contactform.prototype.removeFile = function (uploadListItem, form, inputField, validator, id) {
        // Get the size of the removed attachment
        var attachmentSize = 0;
        form.attachments = form.attachments.filter(function (attachment) {
            if (attachment.id === id) {
                attachmentSize = attachment.size;
            }
            return attachment.id !== id;
        });
        uploadListItem.parentNode.removeChild(uploadListItem);
        // Get new total size and set data attribute on input field
        var totalSize = inputField.dataset.totalFilesize ? parseInt(inputField.dataset.totalFilesize) : 0;
        var newTotalSize = totalSize - attachmentSize;
        inputField.dataset.totalFilesize = newTotalSize.toString();
        inputField.dataset.filecount = form.attachments.length.toString();
        validator.validateField(inputField);
    };
    /**
     * Takes the pure bytes integer as input
     * and return a human-readable file size
     */
    Contactform.prototype.humanFileSize = function (bytes) {
        var thresh = 1000;
        if (Math.abs(bytes) < thresh) {
            return "".concat(bytes, " B");
        }
        var units = ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        var u = -1;
        do {
            bytes /= thresh;
            ++u;
        } while (Math.abs(bytes) >= thresh && u < units.length - 1);
        return (bytes.toFixed(1) + ' ' + units[u]).replace('.', ',');
    };
    Contactform.prototype.createInputFromSearchParam = function (form) {
        var searchParams = new URLSearchParams(window.location.search);
        if (searchParams.has('ncbp_transaction-id') != null) {
            var transactionId = searchParams.get('ncbp_transaction-id');
            var input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'transaction-id';
            input.value = transactionId;
            form.querySelector('input[name=age]').before(input);
        }
    };
    return Contactform;
}());
exports.default = Contactform;
document.addEventListener('DOMContentLoaded', function () {
    console.trace('INFO Contactform.ts loaded');
    document.querySelectorAll('.js-contact-form').forEach(function (form) {
        try {
            new Contactform(form);
        }
        catch (e) {
            console.error('An error while creating a new Contactform instance: {}', e);
        }
    });
    document.querySelectorAll('[data-contactform-dropdown-prefill-activate="true"]').forEach(function (component) {
        try {
            new contactformdropdownprefill_1.default(component);
        }
        catch (e) {
            console.error('An error while creating a new Contactformdropdownprefill instance: {}', e);
        }
    });
    document.querySelectorAll('[data-free-text-field-prefill-activate]').forEach(function (component) {
        try {
            new freeTextFieldPrefill_1.default(component);
        }
        catch (e) {
            console.error('An error while creating a new FreeTextFieldPrefill instance: {}', e);
        }
    });
}, false);
